import styled from 'styled-components'

export const CardStyle = styled.div`
  display: none;

  .inative {
    color: ${({ theme }) => theme.colors.error};
  }

  @media screen and (max-width: 720px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 45%;
    padding: 5px;
    margin: 5px;
    border-radius: ${({ theme }) => theme.borderRadius.normal};
    border: ${({ theme }) => theme.border};
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
    background-color: ${({ theme }) => theme.colors.trueWhite};

    h2 {
      text-align: center;
      margin: 0 0 2px 0;
      padding: 0 0 2px 0;
      border-bottom: ${({ theme }) => theme.border};
      font-size: ${({ theme }) => theme.fonts.size.normal};
      font-weight: ${({ theme }) => theme.fonts.weight.thin};
    }

    p {
      margin: 0 0 3px 0;
    }
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`
